import {View} from 'react-native';
import React from 'react';
import {Props} from './model';
import {useStyles} from '../../../../shared/hooks/styles';
import {images} from '../../../../assets/icons';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {ResponsiveView} from '../../../../shared/components/responsiveView';
import {Screens} from '../../../../shared/routing';
import {useNavigation} from '@react-navigation/native';
import {Button} from '../../../../shared/components/button';
import {Text} from '../../../../shared/components/text';

export default ({privilege}: Props) => {
  const nav = useNavigation();
  const styles = useStyles(({mediaOnly, theme, mediaExclude, addShadow}) => ({
    card: {
      position: 'relative',
      backgroundColor: theme.privilegeCard.backgroundColor,
      borderRadius: 14,
      overflow: 'hidden',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          paddingTop: 40,
          paddingLeft: 47,
          paddingRight: 110,
          paddingBottom: 40,
          minHeight: 230,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...addShadow({
            height: 20,
            radius: 18,
          }),
        },
        {
          paddingTop: 25,
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: 35,
          minHeight: 160,
          ...addShadow({
            height: 2,
            radius: 18,
          }),
        },
      ),
    },
    cardBg: {
      position: 'absolute',
      zIndex: -1,
      right: 0,
      bottom: 0,
      justifyContent: 'flex-end',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          width: 495,
          height: 230,
        },
        {
          width: 328,
          height: 160,
        },
      ),
    },
    cardContent: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginRight: 110,
          flexGrow: 0,
          flexShrink: 1,
        },
        {
          marginBottom: 30,
        },
      ),
    },
    cardText: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
      textAlign: 'left',
      width: '100%',
    },
    cardBottom: {
      flexDirection: 'row',
      justifyContent: 'center',
      ...mediaExclude(DeviceSize.desktop, {marginTop: 'auto'}),
    },
    cardButton: {
      width: 220,
    },
  }));
  return (
    <View style={styles.card}>
      <View style={styles.cardBg}>
        <ResponsiveView only={[DeviceSize.desktop]}>
          <images.PrivilegeCardPattern
            width={styles.cardBg.width as number}
            height={styles.cardBg.height as number}
            hideForVisuallyImpaired
          />
        </ResponsiveView>
        <ResponsiveView exclude={[DeviceSize.desktop]}>
          <images.PrivilegeCardPatternMobile
            width={styles.cardBg.width as number}
            height={styles.cardBg.height as number}
            hideForVisuallyImpaired
          />
        </ResponsiveView>
      </View>
      <View style={styles.cardContent}>
        <Text style={styles.cardText}>{privilege.name}</Text>
      </View>
      <View style={styles.cardBottom}>
        <Button
          id='privileges-description'
          style={styles.cardButton}
          onPress={() => {
            nav.navigate(Screens.PrivilegesServiceDetails, {id: privilege.id});
          }}
          type='secondary'
          text='Подробнее'
        />
      </View>
    </View>
  );
};
